module.exports = __webpack_public_path__ + "static/media/24supportIcon.0b97fb3d.png";